import { render, staticRenderFns } from "./LazyLoadSelect.vue?vue&type=template&id=b3486f84&"
import script from "./LazyLoadSelect.vue?vue&type=script&lang=js&"
export * from "./LazyLoadSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItem,QItemSection})
